import React from 'react';
/**
 * This is simply a button wrapper, add's a div with `role="button"` and a onClick
 */
export var IconButton = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    return (React.createElement("div", { className: "rfu-icon-button", role: "button", onClick: onClick }, children));
};
